// @ vendors
const moment = require('moment');
const get = require('lodash/object/get');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const DATE_FORMAT_SLASHES_ES = 'DD/MM/YYYY';
const UNREAD_COUNT_CACHE_TIME = 10000;
const {
    DEFAULT_NOTIFICATION_LIST_FROM,
    DEFAULT_NOTIFICATION_LIST_FROM_UNIT,
    ORDER_BY_CREATED_ON,
    USER_NOTIFICATIONS_GET_NEXT_SIZE
} = require('constants/index');

const clearUserNotificationsFilters = () => ({
    type: actionTypes.USER_NOTIFICATIONS_FILTERS_CLEAR
});

const requestUserNotificationsInProgress = () => ({
    type: actionTypes.USER_NOTIFICATIONS_REQUEST
});

const requestNextUserNotificationsInProgress = () => ({
    type: actionTypes.USER_NOTIFICATIONS_NEXT_PAGE_REQUEST
});

const requestUserNotificationsSuccess = (data) => ({
    type: actionTypes.USER_NOTIFICATIONS_SUCCESS,
    payload: {
        data: Array.isArray(data.response) ? data.response : [],
        nextPage: get(data, '_links.next_page.href', '')
    }
});

const requestUserNotificationsFailure = (error) => ({
    type: actionTypes.USER_NOTIFICATIONS_FAILURE,
    payload: { error }
});

const setUserNotificationsInProgress = () => ({
    type: actionTypes.SET_USER_NOTIFICATIONS_REQUEST
});

const setUserNotificationsSuccess = () => ({
    type: actionTypes.SET_USER_NOTIFICATIONS_SUCCESS
});

const setUserNotificationsFailure = (error) => ({
    type: actionTypes.SET_USER_NOTIFICATIONS_FAILURE,
    payload: { error }
});

const setCollectiveUserPromptNotification = (response) => ({
    type: actionTypes.SET_COLLECTIVE_USER_PROMPT_NOTIFICATION,
    payload: {
        response
    }
})

const requestUnreadCountNotificationsInProgress = () => ({
    type: actionTypes.USER_UNREAD_NOTIFICATIONS_COUNT_REQUEST,
});

const requestUnreadCountNotificationsSuccess = (data) => ({
    type: actionTypes.USER_UNREAD_NOTIFICATIONS_COUNT_SUCCESS,
    payload: {
        data
    }
});

const requestUnreadCountNotificationsFailure = (error) => ({
    type: actionTypes.FETCH_ACCOUNT_DEBITS_EDIT_VALIDATE_REQUEST,
    payload: {
        error
    }
});

const unreadCountNotificationsInvalidateCache = () => ({
    type: actionTypes.USER_UNREAD_NOTIFICATIONS_COUNT_INVALIDATE_CACHE
});

const requestUserNotifications = (requestParams) => (dispatch, getState) => {
    const isAlreadyFetching = getState().userNotifications.get('isFetching');
    const immDateFilter = getState().userNotifications.getIn(['filters', 'date']);

    // For requestUserNotifications if no dates are
    // selected for the filter, we get notifications from last 4 week (default)
    const defaultFromField = moment()
        .startOf('day')
        .subtract(DEFAULT_NOTIFICATION_LIST_FROM, DEFAULT_NOTIFICATION_LIST_FROM_UNIT);

    const fromDate = immDateFilter.get('from') || defaultFromField;
    const toDate = immDateFilter.get('to') || moment().startOf('day');
    //For initial we need 5 notifications and for next page we need 15 notifications
    const size = requestParams && requestParams.size ? requestParams.size : USER_NOTIFICATIONS_GET_NEXT_SIZE;

    if (!isAlreadyFetching) {
        const params = {
            query: {
                from: fromDate.format(DATE_FORMAT_SLASHES_ES),
                to: toDate.format(DATE_FORMAT_SLASHES_ES),
                orderBy: ORDER_BY_CREATED_ON,
                size: size
            }
        };

        dispatch(requestUserNotificationsInProgress());
        APIGet({
            dispatch,
            endpoint: 'requestUserNotifications',
            params
        })
        .then(response => dispatch(requestUserNotificationsSuccess(response)))
        .catch( response => {
            if (!!response.error) {
                dispatch(requestUserNotificationsFailure(response.error))
            } else {
                throw response;
            }
        });
    }
};

const requestNextUserNotificationsPage = (nextPageURL) => (dispatch, getState) => {
    const isAlreadyFetchingNextPage = getState().userNotifications.get('isFetchingNextPage');

    if (!isAlreadyFetchingNextPage){
        dispatch(requestNextUserNotificationsInProgress());
        return APIGet({
            dispatch,
            url: nextPageURL
        })
        .then(response => dispatch(requestUserNotificationsSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestUserNotificationsFailure(response.error));
            } else {
                throw response;
            }
        });
    }
};

const setUserNotifications = (unreadNotificationIds, callback) => (dispatch, getState) => {
    const isAlreadyReading = getState().userNotifications.get('isReading');
    const requestData = {
        query: {
            messagesIds: unreadNotificationIds
        }
    }
    if (!isAlreadyReading) {
        dispatch(setUserNotificationsInProgress());
        return APIPost({dispatch, url: apiURLBuilder.getURL('setUserNotifications'), params: requestData})
        .then(() => {dispatch(setUserNotificationsSuccess())
            callback();
        })
        .catch( response => {
            if (!!response.error) {
                dispatch(setUserNotificationsFailure(response.error))
            } else {
                throw response;
            }
        })
    }
};

const setUnreadNotificationsCount = () => (dispatch, getState) => {
    const isAlreadyReading = getState().userNotifications.get('isReading');
    const unreadCountCached = getState().userNotifications.get('unreadCountCached');
    if (!isAlreadyReading && !unreadCountCached) {
        dispatch(requestUnreadCountNotificationsInProgress());
        APIGet({
            dispatch,
            endpoint: 'setUnreadNotificationsCount'
        })
        .then(response => {
            setTimeout(() => dispatch(unreadCountNotificationsInvalidateCache()),UNREAD_COUNT_CACHE_TIME);
            dispatch(requestUnreadCountNotificationsSuccess(response))
        })
        .catch( response => {
            if (!!response.error) {
                dispatch(requestUnreadCountNotificationsFailure(response.error))
            } else {
                throw response;
            }
        });
    }
};

const setNotificationsFilters = (filters) => ({
    type: actionTypes.USER_NOTIFICATIONS_SET_FILTERS,
    payload: {
        filters
    }
});

const setProspectDisclaimerClosed = () => ({
    type: actionTypes.SET_USER_NOTIFICATION_PROSPECT_CLOSED
});

const setProspectDisclaimerPrompt = () => ({
    type: actionTypes.SET_USER_NOTIFICATION_PROSPECT_PROMPT
});

module.exports = {
    clearUserNotificationsFilters,
    requestUserNotifications,
    requestNextUserNotificationsPage,
    setCollectiveUserPromptNotification,
    setProspectDisclaimerClosed,
    setProspectDisclaimerPrompt,
    setUnreadNotificationsCount,
    setUserNotifications,
    setNotificationsFilters
};
